/* This file was generated by running "node scripts/generateTranslations.js". */
/* Created: 2026-09-10 13:57:07 */

const Keys = {
  edit: 'edit',
  update: 'update',
  cancel: 'cancel',
  phoneNumber: 'phoneNumber',
  password: 'password',
  passwordConfirm: 'passwordConfirm',
  success: 'success',
  error: 'error',
  passwordPolicyInformation: 'passwordPolicyInformation',
  minLength: 'minLength',
  maxLength: 'maxLength',
  excludeWhitespaces: 'excludeWhitespaces',
  minMatchingCharRules: 'minMatchingCharRules',
  minUppercaseChar: 'minUppercaseChar',
  minLowercaseChar: 'minLowercaseChar',
  minNumericChar: 'minNumericChar',
  minSpecialChar: 'minSpecialChar'
}; export default Keys;